import {Footer} from './Components/Footer'
import Quiz from './Components/Quiz'

function App() {
  return (
    <>
      <Quiz />
      <Footer />
    </>
  );
}

export default App;
